<template>
    <div class="tsa-hashButton" ref="hashButton">
        <div class="hashButton" @click="choose">
            <span class="tsa-icon-xuanzewenjian"></span>
            <p>选择文件</p>
        </div>
        <input type="file" hidden ref="hashInput" @change="changeFile">
        <p v-if="fileNameShow" class="fileName ellipsis">{{ fileName }}</p>
        <TsaTooltipV2 v-else :message="fileName">
            <p class="fileName ellipsis">{{ fileName }}</p>
        </TsaTooltipV2>
        <!-- 清空按钮 -->
        <span class="close tsa-icon-close2" v-if="fileName" @click="close"></span>
        <div class="percent-dialog" v-show="dialogShow">
            <div class="mask"></div>
            <div class="content">
                <el-progress type="circle" :percentage="percentage"></el-progress>
            </div>
        </div>
    </div>
</template>

<script>
import { hashFile } from '@/common/copyright/fileHash.js'
export default {
    props: {
        value: {
            type: String | null,
            default: ''
        }
    },
    data () {
        return {
            dialogShow: false,
            fileNameShow: true,
            fileName: '',
            percentage: 0,
        }
    },
    watch: {
        value (val) {
            console.log(val)
            console.log('*********')
            if (!val) {
                this.reset()
            }
        }
    },
    mounted () {
        
    },
    methods: {
        close () {
            this.reset()
            this.$emit('input', null)
            this.$emit('on-success', null)
        },
        choose () {
            this.$refs.hashInput.click()
        },
        reset () {
            this.$refs.hashInput.value = ''
            this.percentage = 0
            this.fileName = ''
            this.fileNameShow = false
        },
        changeFile (e) {
            this.dialogShow = true
            let file = e.target.files[0]
            this.fileName = file.name
            this.$nextTick(() => {
                let el = document.querySelector('.tsa-hashButton .fileName')
                console.log(el.clientWidth, el.scrollWidth)
                if (el.clientWidth >= el.scrollWidth) {
                    this.fileNameShow = true
                } else {
                    this.fileNameShow = false
                }
            })
            hashFile(file, 'SHA256', (percentage) => {
                this.percentage = percentage
            }).then(res => {
                setTimeout(() => {
                    this.dialogShow = false
                    this.$refs.hashInput.value = ''
                    this.percentage = 0
                    this.$emit('input', res)
                    this.$emit('on-success', res)
                }, 1000);
            }).catch(() => {
                this.dialogShow = false
                this.reset()
                this.$TsaToastV2.show({
                    message: '文件哈希值计算失败',
                    type: 'error',
                })
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.tsa-hashButton {
    width: 100%;
    display: flex;
    align-items: center;
    .hashButton {
        flex-shrink: 0;
        width: 120px;
        min-width: 100px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        border: 1px solid #C9D1DC;
        cursor: pointer;
        margin-right: 15px;
        &:hover {
            border: 1px solid #2468F2;
            span {
                color: #2468F2;
            }
            p {
                color: #2468F2;
            }
        }
        span {
            font-size: 16px;
            color: #344156;
            margin-right: 8px;
        }
        p {
            font-size: 14px;
            color: #344156;
        }
    }
    .fileName {
        max-width: 324px;
        font-size: 14px;
        color: #151B26;
        word-break: break-all;
        cursor: pointer;
        margin-right: 6px;
    }
    .close {
        flex-shrink: 0;
        font-size: 17px;
        color: #84868C;
        cursor: pointer;
        &:hover {
            color: #2468F2;
        }
    }
    .percent-dialog {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 9999;
        .mask {
            position: relative;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            z-index: 1;
        }
        .content {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            z-index: 2;
            /deep/.el-progress{
                .el-progress__text {
                    color: #ffffff;
                }
            }
        }
    }
}
</style>